<div id="overlay" *ngIf="loading">
  <img
    src="/assets/loading.gif"
    width="50"
    style="position: fixed; top: 50%; left: 50%; z-index: 1"
  />
</div>
